import { components, default as ReactSelect } from 'react-select';
import styles from './Select.module.css';
import inputStyles from '../InputLabel/Input.module.css';
import { useEffect, useState } from 'react';
import InputLabel from '../InputLabel/InputLabel';
import { Icon } from '../index';
import { Icons } from '../Icon/Icon';
import { ActionMeta, OnChangeValue } from 'react-select/dist/declarations/src/types';

const CustomChevron = ({ innerRef, ...innerProps }: any) => {
    return (
        <components.DropdownIndicator {...innerProps}>
            <svg
                ref={innerRef}
                xmlns="http://www.w3.org/2000/svg"
                width="19.931"
                height="10.673"
                viewBox="0 0 19.931 10.673"
                style={{
                    transform: innerProps.selectProps.menuIsOpen ? 'rotate(-180deg)' : '',
                }}
            >
                <path
                    id="Path_1174"
                    data-name="Path 1174"
                    d="M5271.342,2230l9.612,9.612,9.612-9.612"
                    transform="translate(-5270.988 -2229.646)"
                    fill="none"
                    stroke="currentcolor"
                    strokeWidth="1"
                />
            </svg>
        </components.DropdownIndicator>
    );
};

const CustomMenu = ({
    placement,
    selectProps,
    innerRef,
    innerProps,
    isDisabled,
    children,
    fullWidth,
    ...props
}: any) => {
    // Update the parent component with the current placement
    if (selectProps.onPlacementChange) {
        selectProps.onPlacementChange(placement);
    }

    return !isDisabled ? (
        <div
            ref={innerRef}
            {...innerProps}
            className={`${styles.dropdownMenu} ${placement === 'top' ? styles.dropdownTop : styles.dropdownBottom}`}
        >
            {selectProps.filters && (
                <div className={styles.filterContainer}>
                    <div className={styles.filtersOuter}>
                        <div className={styles.filters}>
                            {selectProps.filters.map((f: string, i: number) => (
                                <button
                                    key={i}
                                    type="button"
                                    className={`${styles.filter} ${selectProps.selectedFilters.includes(f) ? styles.selectedFilter : ''}`}
                                    onClick={() => {
                                        selectProps.onFilterSelect(f);
                                    }}
                                >
                                    {f}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className={styles.filterStatus}>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6.75" viewBox="0 0 10 6.75">
                                <g id="Group_7136" data-name="Group 7136" transform="translate(-1486.5 -1541.625)">
                                    <line
                                        id="Line_158"
                                        data-name="Line 158"
                                        x2="10"
                                        transform="translate(1486.5 1542)"
                                        fill="none"
                                        stroke="#707070"
                                        strokeWidth="0.75"
                                    />
                                    <line
                                        id="Line_159"
                                        data-name="Line 159"
                                        x2="6"
                                        transform="translate(1488.5 1545)"
                                        fill="none"
                                        stroke="#707070"
                                        strokeWidth="0.75"
                                    />
                                    <line
                                        id="Line_160"
                                        data-name="Line 160"
                                        x2="2"
                                        transform="translate(1490.5 1548)"
                                        fill="none"
                                        stroke="#707070"
                                        strokeWidth="0.75"
                                    />
                                </g>
                            </svg>
                        </span>
                        Filter{' '}
                        <span className={styles.selectedFiltersIndicator}>
                            {selectProps.selectedFilters.length || 0}
                        </span>
                    </div>
                </div>
            )}
            {/*{props.isMulti && !!selectProps.value?.length && (*/}
            {/*    <div style={{ padding: '8px 3px' }}>*/}
            {/*        <div*/}
            {/*            style={{*/}
            {/*                display: 'flex',*/}
            {/*                flexWrap: 'wrap',*/}
            {/*                gap: '4px',*/}
            {/*                paddingBottom: '8px',*/}
            {/*                borderBottom: '1px solid var(--light-grey)',*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            {selectProps.value.map((option: any, index: number) => (*/}
            {/*                <div*/}
            {/*                    key={option.value + index}*/}
            {/*                    onClick={(e) => {*/}
            {/*                        e.stopPropagation();*/}
            {/*                        props.setValue(selectProps.value.filter((v: any) => v.value !== option.value));*/}
            {/*                    }}*/}
            {/*                    style={{*/}
            {/*                        padding: '2px 4px',*/}
            {/*                        background: '#dedede',*/}
            {/*                        borderRadius: '4px',*/}
            {/*                        cursor: 'pointer',*/}
            {/*                    }}*/}
            {/*                >*/}
            {/*                    <span>{option.label}</span>*/}
            {/*                </div>*/}
            {/*            ))}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*)}*/}

            {children}

            {!!selectProps.onCreateOption && (
                <div className={styles.addOptionContainer}>
                    <button
                        type={'button'}
                        className={styles.addOptionBtn}
                        onClick={() => {
                            selectProps.onCreateOption();
                            selectProps.onMenuClose();
                        }}
                    >
                        <Icon icon={Icons.add} /> Add another
                    </button>
                </div>
            )}
        </div>
    ) : null;
};

const CustomValueContainer = (props: any) => {
    const selected = props.getValue();
    const content = ((length) => {
        switch (length) {
            case 0:
                return '';
            case 1:
                return selected[0].label;
            default:
                return `${selected.length} selected`;
        }
    })(selected.length);

    return (
        <components.ValueContainer {...props}>
            {props.isMulti && <div>{content}</div>}
            {props.children}
        </components.ValueContainer>
    );
};

const CustomSelect = ({
    children,
    options = [],
    value,
    valueKey = 'value',
    labelKey = 'label',
    filterKey,
    isMulti = false,
    onCreateOption,
    onChange,
    disabled,
    info,
    extended,
    placeholder,
    style,
    afterLabel,
    menuPlacement,
    margin,
    ...props
}: any) => {
    const [customValue, setCustomValue] = useState<any>(undefined);
    const [_menuPlacement, setMenuPlacement] = useState<string>('bottom');

    const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

    const getValue = () => {
        const option = !value
            ? ''
            : Array.isArray(value)
              ? value
              : typeof value !== 'object'
                ? options.find((option: any) => (option[valueKey] || option.value) === value)
                : value;

        const endValue = Array.isArray(value)
            ? value
            : option
              ? {
                    label: option[labelKey] || option.label || option.name,
                    value: option[valueKey] || option.value || option.id,
                }
              : '';

        // console.log('customValue', customValue);
        // console.log('endValue', endValue);
        // console.log('option', option);
        if (JSON.stringify(customValue) != JSON.stringify(endValue)) {
            setCustomValue(
                Array.isArray(value)
                    ? value
                    : option
                      ? {
                            label: option[labelKey] || option.label || option.name,
                            value: option[valueKey] || option.value || option.id,
                        }
                      : '',
            );
        }
    };

    useEffect(() => {
        getValue();
    }, [value, options]);

    // useEffect(() => {
    // setSelectedFilters([]);
    // }, [options]);

    // const handleChange = (selectedValue: OnChangeValue<Option, IsMulti>, options: ActionMeta<Option>) => {
    const handleChange = (selectedValue: OnChangeValue<any, any>, options: ActionMeta<any>) => {
        // console.log('value', selectedValue, options, value);
        // console.log('customValue', customValue);

        if (onChange) {
            if (isMulti && Array.isArray(value) && value.find((v) => v[valueKey] == options.option.value)) {
                if (Array.isArray(value)) {
                    console.log(
                        value.find((v) => v[valueKey] == options.option.value),
                        value.filter((v) => v[valueKey] != options.option.value && v.value != options.option.value),
                    );
                }

                onChange(
                    value.filter((v) => v[valueKey] != options.option.value && v.value != options.option.value),
                    options,
                );
            } else {
                onChange(selectedValue, options);
            }
        }
    };

    const onFilterSelect = (filter: string) => {
        // console.log('f', filter);
        if (selectedFilters.indexOf(filter) == -1) {
            setSelectedFilters([...new Set([...selectedFilters, filter])]);
        } else {
            setSelectedFilters(selectedFilters.filter((v) => v !== filter));
        }
    };

    const filterOption = (candidate: any, input: any) => {
        // console.log('candidate', candidate);
        // console.log('f', selectedFilters);
        return (
            !selectedFilters.length || !!(selectedFilters.length && selectedFilters.includes(candidate.data[filterKey]))
        );
    };

    return (
        <InputLabel
            label={children}
            extended={extended}
            info={info}
            style={style}
            afterLabel={afterLabel}
            margin={margin}
        >
            <ReactSelect
                onCreateOption={onCreateOption}
                onChange={handleChange}
                isMulti={isMulti}
                isDisabled={disabled}
                // defaultValue={customValue}
                value={customValue}
                filterOption={filterOption}
                options={options.map((option: any) => ({
                    label: option[labelKey] || option.label,
                    value: option[valueKey] || option.value,
                    ...option,
                }))}
                components={{
                    Menu: CustomMenu,
                    DropdownIndicator: CustomChevron,
                    ValueContainer: CustomValueContainer,
                    MultiValue: () => null, // Hide individual tags
                    IndicatorSeparator: () => null,
                }}
                // @ts-expect-error: custom types needed
                onPlacementChange={setMenuPlacement}
                filters={filterKey ? [...new Set(options.map((option: any) => option[filterKey]))] : undefined}
                selectedFilters={selectedFilters}
                onFilterSelect={onFilterSelect}
                unstyled={true}
                placeholder={placeholder || 'Select...'}
                menuPlacement={menuPlacement || 'auto'}
                minMenuHeight={160}
                maxMenuHeight={200}
                closeMenuOnSelect={!isMulti}
                isClearable={false}
                isSearchable={false}
                hideSelectedOptions={false}
                // menuPortalTarget={document.body}
                // menuPosition={'fixed'}
                theme={(theme) => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                        ...theme.colors,
                        primary25: 'hotpink',
                        primary: 'black',
                    },
                })}
                styles={{
                    menu: (provided: any) => ({
                        ...provided,
                        borderRadius: 0,
                        zIndex: 999,
                    }),
                }}
                classNames={{
                    menuList: (state) => `${styles.menuList}`,
                    control: (state) =>
                        `${inputStyles.inputField} 
                        ${inputStyles.selectField} 
                        ${styles.select} 
                        ${state.menuIsOpen ? inputStyles.focused : ''} 
                        ${state.isDisabled ? inputStyles.disabled : ''} 
                        ${state.hasValue ? inputStyles.selected : ''}
                        ${
                            state.isMulti &&
                            Array.isArray(state.selectProps.value) &&
                            state.selectProps.value.length > 1
                                ? inputStyles.selectedMulti
                                : ''
                        }
                        ${
                            state.menuIsOpen
                                ? (() => {
                                      const className =
                                          _menuPlacement === 'top' ? inputStyles.controlTop : inputStyles.controlBottom;
                                      return className;
                                  })()
                                : ''
                        }
                        `,
                    option: (state) =>
                        `${styles.option} ${
                            state.isSelected ||
                            (state.isMulti &&
                                Array.isArray(state.selectProps.value) &&
                                // @ts-expect-error: custom types needed
                                state.selectProps.value?.find((v: any) => v[valueKey] === state.value))
                                ? styles.optionSelected
                                : ''
                        }`,
                    clearIndicator: (state) => styles.clearIndicator,
                    noOptionsMessage: (state) => `
                        ${styles.noOptionsMessage}
                        ${props.readOnly ? styles.readOnly : ''} 
                    `,
                    multiValue: (state) => styles.multiValue,
                }}
                // closeMenuOnScroll={(e) => {
                //     // if (e.target === document) {
                //     return true;
                //     // } else {
                //     //     return false;
                //     // }
                // }}
            />
        </InputLabel>
    );
};

export default CustomSelect;
